<template>
	<div id="prizelist" class="page">
		<div class="prizelist">
			<div class="prize" v-for="item in prizeList" v-on:click="event_submit(item)">
				<img v-bind:src="item.avatar"/>
				<span>{{item.nickname}}</span>
			</div>
		</div>
		<div class="null-box" v-if="!prizeList.length">
			<i class="iconfont icon-ico_meiyoushuju"></i>
			<p>您还没有学员呢</p>
		</div>
	</div>
</template>

<script>
import { Toast } from 'we-vue'
export default {
  data () {
    return {
		prizeList:[]
	}
  },
  mounted () {
	
  },
  created(){
	this.$app.pr('api/prize/userlist').then((res) => {
		this.prizeList = res.data.userList
	})
  },
  methods:{
	  	event_submit(item){
			this.$store.state.prizeUserChecked = item
			this.$wx.navigateBack()
		}
  },
  filters: {
    pickerValueFilter (val) {
      if (Array.isArray(val)) {
        return val.toString()
      } else {
        return '请选择'
      }
    }
  }
}
</script>

<style scoped>
	#prizelist{
		background-color:#f4fcff;
		min-height:100vh;
	}
	.prizelist{
		padding:3vw;
	}
	.prizelist .prize{
		display:inline-block;
		width:22vw;
		border-radius:3vw;
		box-shadow:0px 0px 6px #CCCCCC;
		margin-bottom:3vw;
		margin-right:2vw;
	}
	.prizelist .prize img{
		width:100%;
		height:22vw;
	}
	.prizelist .prize:nth-child(4n){
		margin-right:0vw;
	}
	.prize span{
		line-height:10vw;
		text-align:center;
		display:block;
		height:10vw;
		overflow:hidden;
	}
</style>


// WEBPACK FOOTER //
// src/components/Prizeuser.vue